import { subscribe, deleteAd, getMediaPublicUrl } from "../ads-state.js";
import { ORIENTATION_LABELS_TR, GENDER_LABELS_TR } from "../constants.js";
import { openFormModal } from "./form-modal.js";
import { toast } from "./toast.js";

function escapeHtml(s) {
  return String(s == null ? "" : s)
    .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;").replace(/'/g, "&#39;");
}

function renderRow(ad) {
  const orient = ORIENTATION_LABELS_TR[ad.orientation || "any"] || "Tümü";
  const ages = (ad.age_brackets || []).join(", ") || "—";
  const genders = (ad.genders || []).map(g => GENDER_LABELS_TR[g] || g).join(", ") || "—";
  const status = ad.enabled === false
    ? `<span class="text-[9px] uppercase text-red-400 font-bold">Pasif</span>`
    : `<span class="text-[9px] uppercase text-emerald-400 font-bold">Aktif</span>`;
  const thumb = ad.media_path
    ? `<img src="${escapeHtml(getMediaPublicUrl(ad.media_path))}" class="w-10 h-10 object-cover rounded" alt=""/>`
    : `<div class="w-10 h-10 rounded bg-slate-800 flex items-center justify-center text-slate-600 text-[10px]">—</div>`;

  return `
    <tr class="border-b border-slate-800 hover:bg-slate-800/40 transition-colors cursor-pointer" data-id="${escapeHtml(ad.id)}">
      <td class="px-3 py-2">${thumb}</td>
      <td class="px-3 py-2">
        <div class="font-bold text-sm">${escapeHtml(ad.title)}</div>
        <div class="text-[10px] text-slate-500 font-mono">${escapeHtml(ad.id)}</div>
      </td>
      <td class="px-3 py-2 text-xs uppercase">${escapeHtml(ad.media_type)}</td>
      <td class="px-3 py-2 text-xs">${escapeHtml(orient)}</td>
      <td class="px-3 py-2 text-xs">${escapeHtml(ages)}</td>
      <td class="px-3 py-2 text-xs">${escapeHtml(genders)}</td>
      <td class="px-3 py-2 text-xs tabular-nums">${ad.duration_sec}s</td>
      <td class="px-3 py-2 text-xs tabular-nums">${ad.priority ?? 5}</td>
      <td class="px-3 py-2">${status}</td>
      <td class="px-3 py-2 text-right">
        <button data-action="delete" data-id="${escapeHtml(ad.id)}"
                class="text-[10px] text-red-400 hover:text-red-300 px-1.5 py-0.5">Sil</button>
      </td>
    </tr>`;
}

function renderTable(ads) {
  const host = document.getElementById("ads-table-host");
  if (!host) return;
  const count = document.getElementById("ad-count");
  if (count) count.textContent = ads.length;

  if (ads.length === 0) {
    host.innerHTML = `
      <div class="p-12 text-center text-slate-500 italic">
        Henüz reklam yok. <strong>+ Reklam Ekle</strong> ile başla.
      </div>`;
    return;
  }

  host.innerHTML = `
    <table class="w-full text-left">
      <thead class="bg-slate-900 text-[10px] uppercase tracking-widest text-slate-500 border-b border-slate-800">
        <tr>
          <th class="px-3 py-2"></th>
          <th class="px-3 py-2">Reklam</th>
          <th class="px-3 py-2">Tip</th>
          <th class="px-3 py-2">Yön</th>
          <th class="px-3 py-2">Yaş</th>
          <th class="px-3 py-2">Cinsiyet</th>
          <th class="px-3 py-2">Süre</th>
          <th class="px-3 py-2">Öncelik</th>
          <th class="px-3 py-2">Durum</th>
          <th class="px-3 py-2"></th>
        </tr>
      </thead>
      <tbody>${ads.map(renderRow).join("")}</tbody>
    </table>`;

  host.querySelectorAll("tr[data-id]").forEach((row) => {
    row.addEventListener("click", (e) => {
      const target = e.target;
      if (target.dataset && target.dataset.action === "delete") return;
      openFormModal(row.dataset.id);
    });
  });
  host.querySelectorAll('[data-action="delete"]').forEach((btn) => {
    btn.addEventListener("click", async (e) => {
      e.stopPropagation();
      const id = btn.dataset.id;
      if (!confirm(`'${id}' silinsin mi?`)) return;
      try {
        await deleteAd(id);
        toast(`'${id}' silindi`, "ok");
      } catch (err) {
        toast(err.message || "Silme hatası", "error");
      }
    });
  });
}

export function initAdsTable() {
  subscribe(renderTable);
}
